export default __webpack_public_path__ + "static/media/aaron-burden-Kp9z6zcUfGw-unsplash.4f7d44ea.jpg";